import React, { useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { usePage } from 'api/wordpress/page';
import ApiLoader from 'components/loading/ApiLoader';
import { sanitizer } from 'utils/sanitizer';
import HelmetComponent from 'components/shared/HelmetComponent';
import PageHeader from 'components/shared/PageHeader';

const Dynamic: React.FC = () => {
  const routeParams = useParams<{ [key: string]: string }>();
  const query = usePage<any>(routeParams.slug, undefined, { enabled: false });
  const queryRef = useRef(query);

  useEffect(() => {
    queryRef.current = query;
  }, [query]);

  useEffect(() => {
    queryRef.current.refetch();
  }, [routeParams]);
  return (
    <>
      <HelmetComponent title={query.data?.title} />
      <ApiLoader status={query.status} errorCodes={query.error?.errors}>
        {query.data && (
          <>
            <PageHeader title={query.data?.title} />
            <div
              className="dynamic-wrapper content-wrapper page-content-bottom-padding"
              dangerouslySetInnerHTML={{ __html: sanitizer(query.data.content) }}
            />
          </>
        )}
      </ApiLoader>
    </>
  );
};

export default Dynamic;
